export var VENDOR_DISCLOSURE_COLOR = '#d64003';
export var VENDOR_DISCLOSURE_ICON_COLORS = {
  background: '#fff',
  border: VENDOR_DISCLOSURE_COLOR,
  text: VENDOR_DISCLOSURE_COLOR
};
export var EMPHASIZED_STYLE = {
  FONT_SIZE: '16px',
  FONT_WIDTH: '700'
};